import { render } from "./DockerImageToTar.vue?vue&type=template&id=6775a5ad"
import script from "./DockerImageToTar.vue?vue&type=script&lang=js"
export * from "./DockerImageToTar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__